const State = cc.Enum({
    IDLE: 'IDLE',
    DRAW: 'DRAW'
});

cc.Class({
    extends: cc.Component,

    properties: {
    },

    onLoad () {
        this.gr = this.getComponent(cc.Graphics);
        this.state = State.IDLE;

        this.map = [];
    },

    drawLines (points) {
        this.map.length = 0;
        this.map.push(points);
        this.state = State.DRAW;
        this.updateCustom();
    },

    addLines (points) {
        this.map.push(points);
        this.state = State.DRAW;
        this.updateCustom();
    },

    clearLines () {
        this.state = State.IDLE;
        this.map.length = 0;
        this.gr.clear();
    },

    updateCustom () {

        if (this.state !== State.DRAW) {
            return;
        }

        this.gr.clear();

        this.map.forEach((points) => {
            let i = 0;
            let point = this.node.convertToNodeSpaceAR(points[i]);

            point.x *= this.node.scaleX;
            point.y *= this.node.scaleY;

            this.gr.moveTo(point.x, point.y);
            i++;
            while (i < points.length) {
                point = this.node.convertToNodeSpaceAR(points[i]);
                point.x *= this.node.scaleX;
                point.y *= this.node.scaleY;
                this.gr.lineTo(point.x, point.y);
                i++;
            }
            this.gr.stroke();
        });
    }
});
